import { MutationFn } from '@percent/education-hosted-form/hooks/useMutation/useMutation.types'
import { CreateValidationSubmissionProps, ValidationSubmissionResponse } from './validationSubmission.types'

export const createValidationSubmission: MutationFn<
  CreateValidationSubmissionProps,
  ValidationSubmissionResponse
> = async (client, data, requestConfig) => {
  const response = await client.post('v1/validation-submissions', data, requestConfig)

  return response.data
}
